export default {
  title: 'Activez les notifications pour des offres exclusives & mises à jour',
  description: 'Suivez vos commandes en temps réel. Statut de livraison. Promos & avantages exclusifs.',
  buttons: {
    confirm: 'Activer',
    cancel: 'Pas maintenant',
  },
};
